<script lang="ts">
  import { DirectusImage, Preset } from '@do/svelte-directus-images';

  import { DateFormatter } from '@shared/utils';

  import { ArticleInfo } from '@entities/news';
  import type { NewsFromOneResponse } from '@entities/news/types';

  export let title: string;
  export let publicationDate: string | null;
  export let cover: NewsFromOneResponse['cover'];
  export let author: NewsFromOneResponse['author'];
  export let readTime: number | null;

  const dateFormatter = new DateFormatter();

  const date = dateFormatter.formatLong(publicationDate);
</script>

<section>
  <div class="mx-auto mb-5 max-w-[744px] md:mb-8">
    <h1 class="mb-3 pt-6 text-4xl font-medium md:mb-4 md:pt-8 md:text-6xl">
      {title}
    </h1>

    <ArticleInfo publicationDate="{date}" {author} {readTime} />
  </div>

  {#if cover}
    <div class="mx-auto mb-6 h-auto w-full max-w-[880px] md:mb-8">
      <DirectusImage
        imageData="{cover}"
        pictureSizes="{{
          default: '100vw',
        }}"
        presetKeys="{Preset.Thumbnail}"
        alt="{title}"
        imgClasses="w-full h-full object-contain rounded-lg"
        loading="lazy"
      />
    </div>
  {/if}
</section>
